export class Language {
  id: number;
  lang: string;
  item: string;
  text: string;
}
